var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("SearchBarController", [
    "$scope",
    "$http",
    "$q",
    "$filter",
    "configs",
    "$timeout",
    "elasticService",
    "urlService",
    function (
        $scope,
        $http,
        $q,
        $filter,
        configs,
        $timeout,
        elasticService,
        urlService
    ) {
        //#region Properties
        var searchTimer;
        $scope.searchTerm = "";
        $scope.headerSearch = false;
        $scope.suggestedProducts = [];
        $scope.suggestedTerms = [];
        $scope.suggestedCategoryList = undefined;
        $scope.suggestedBrandList = undefined;
        $scope.searchDefinitionName = "all";
        $scope.searchURL = "";
        $scope.highlightedItemIndex = -1;
        //#endregion

        //#region Functions

        $scope.getProductUrl = function (definitionName, vendor, name, id) {
            return urlService.getProductUrl({
                definitionName: definitionName,
                catalogId: vendor,
                name: name,
                sku: id,
            });
        };

        $scope.getImageUrl = function (definitionName, vendor, prdId) {
            vendor = vendor.replace(/ /g, "_");
            return urlService.getImageUrl({
                definitionName: definitionName,
                size: "large",
                catalogId: vendor,
                sku: prdId,
            });
        };

        $scope.suggest = function () {
            $timeout.cancel(searchTimer);
            // debounces api calls for 1s
            searchTimer = $timeout(function () {
                if ($scope.searchTerm != "" && $scope.searchTerm.length >= 3) {
                    $scope.showNoresults = false;
                    //1. Suggested Terms
                    $scope.httpGetSuggestedTerms().then(function (promise) {
                        $scope.suggestedTerms =
                            promise.suggest.keywordSuggest[0].options || [];
                    });

                    //2. Products query
                    $scope.httpGetSuggestedProducts().then(function (promise) {
                        var customSuggestion = {};
                        if (checkIsCustomDigitizing()) {
                            customSuggestion = {
                                imageUrl: "/cdtype.png",
                                url: "/customdigitizing",
                                _source: {
                                    brand: "Embroiderydesigns.com",
                                    name: "Custom Digitizing",
                                    itemId: "CD01-Custom Design",
                                    definitionName: "CustomDigitizing",
                                },
                            };
                            promise.hits.hits.splice(0, 0, customSuggestion);
                        } else if (checkIsSVG()) {
                            customSuggestion = {
                                imageUrl: "/svgtype.png",
                                url: "/printart/productlistings?ht=true",
                                _source: {
                                    name: "ALL SVG Files",
                                    brand: "Embroiderydesigns.com",
                                    itemId: "N/A",
                                    definitionName: "SVG",
                                },
                            };
                            promise.hits.hits.splice(0, 0, customSuggestion);
                        }
                        $scope.suggestedProducts = promise.hits.hits || [];
                    });

                    //3. Brand Search
                    $scope.httpGetsuggestedBrandList().then(function (promise) {
                        $scope.suggestedBrandList =
                            promise.aggregations.brandlist.buckets || [];
                    });

                    //4. Search for matching Categories
                    $scope
                        .httpGetSuggestedCategoryList()
                        .then(function (promise) {
                            $scope.suggestedCategoryList =
                                promise.aggregations.categoryList.buckets || [];
                        });

                    if (
                        $scope.suggestedBrandList != undefined &&
                        ($scope.suggestedBrandList.length > 0 ||
                            $scope.suggestedCategoryList.length > 0)
                    ) {
                        $scope.filterLimit = 2;
                    } else {
                        $scope.filterLimit = 5;
                    }
                    if (
                        (angular.isUndefined($scope.suggestedCategoryList) ||
                            (angular.isDefined($scope.suggestedCategoryList) &&
                                $scope.suggestedCategoryList.length == 0)) &&
                        (angular.isUndefined($scope.suggestedBrandList) ||
                            (angular.isDefined($scope.suggestedBrandList) &&
                                $scope.suggestedBrandList.length == 0)) &&
                        (angular.isUndefined($scope.suggestedTerms) ||
                            (angular.isDefined($scope.suggestedTerms) &&
                                $scope.suggestedTerms.length == 0)) &&
                        (angular.isUndefined($scope.suggestedProducts) ||
                            (angular.isDefined($scope.suggestedProducts) &&
                                $scope.suggestedProducts.length == 0))
                    ) {
                        $scope.showNoresults = true;
                        $scope.applySearchBackground(false);
                    }
                    $scope.getSearchURL();
                    $scope.applySearchBackground(true);
                } else {
                    $scope.suggestedProducts = undefined;
                    $scope.suggestedTerms = undefined;
                    $scope.suggestedCategoryList = undefined;
                    $scope.suggestedBrandList = undefined;
                    $scope.filterLimit = 5;
                    $scope.showNoresults = false;
                    $scope.applySearchBackground(false);
                }
            }, 350);
        };

        $scope.applySearchBackground = function (isOn) {
            var bckGround = document.getElementById("backgroundSearch");
            if (angular.isDefined(bckGround)) {
                if (isOn) {
                    bckGround.classList.add("search-background");
                    if (document.body.clientWidth >= 1180)
                        document.getElementById(
                            "divSearchBar"
                        ).style.marginLeft = "-35px";
                } else {
                    bckGround.classList.remove("search-background");
                    document.getElementById("divSearchBar").style.marginLeft =
                        "0";
                }
            }
        };

        $scope.httpGetSuggestedProducts = function () {
            var deferred = $q.defer();
            var e = document.getElementById("ddlSearchDefName");
            if (angular.isDefined(e)) {
                $scope.searchDefinitionName = e.value;
            } else {
                $scope.searchDefinitionName = "all";
            }
            elasticService
                .getElasticData(
                    elasticService.buildSuggestedProductsRequest(
                        $scope.searchTerm.toLowerCase(),
                        $scope.searchDefinitionName
                    )
                )
                .then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject("error");
                    }
                );
            return deferred.promise;
        };

        $scope.httpGetSuggestedTerms = function () {
            var deferred = $q.defer();
            elasticService
                .getKeywordsElasticData(
                    elasticService.buildSuggestedTermsRequest($scope.searchTerm)
                )
                .then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject("error");
                    }
                );
            return deferred.promise;
        };

        $scope.httpGetSuggestedCategoryList = function () {
            var deferred = $q.defer();
            elasticService
                .getElasticData(
                    elasticService.buildSuggestedCategoriesRequest(
                        $scope.searchTerm.toLowerCase()
                    )
                )
                .then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject("error");
                    }
                );
            return deferred.promise;
        };

        $scope.httpGetsuggestedBrandList = function () {
            var deferred = $q.defer();
            elasticService
                .getElasticData(
                    elasticService.buildSuggestedBrandsRequest(
                        $scope.searchTerm.toLowerCase()
                    )
                )
                .then(
                    function (success) {
                        deferred.resolve(success.data);
                    },
                    function (error) {
                        deferred.reject("error");
                    }
                );
            return deferred.promise;
        };

        $scope.setSearchTerm = function (v) {
            $scope.searchTerm = $filter("lowercase")(v);
            $scope.highlightedItemIndex = -1;
            $scope.search();
        };

        $scope.changeSelection = function (event, value) {
            $scope.headerSearch = !$scope.headerSearch;
            if (value > 0) $scope.headerSearch = true;
            else $scope.headerSearch = false;
            switch (event.keyCode) {
                case 38: // Up
                    if ($scope.highlightedItemIndex > -1)
                        $scope.highlightedItemIndex--;
                    else if ($scope.highlightedItemIndex <= -1)
                        $scope.highlightedItemIndex = -1;
                    break;
                case 40: // Down
                    if (
                        $scope.highlightedItemIndex >=
                        $scope.suggestedTerms.length - 1
                    )
                        $scope.highlightedItemIndex =
                            $scope.suggestedTerms.length - 1;
                    else if (
                        $scope.highlightedItemIndex <
                        $scope.suggestedTerms.length
                    )
                        $scope.highlightedItemIndex++;
                    break;
                case 13: // Enter
                    $scope.search();
                    event.preventDefault();
                default:
                    break;
            }
        };

        $scope.search = function () {
            if ($scope.searchTerm != "") {
                if ($scope.highlightedItemIndex > -1) {
                    $scope.searchTerm =
                        $scope.suggestedTerms[$scope.highlightedItemIndex].text;
                }
                if (typeof gtag !== "undefined" && gtag !== null) {
                    gtag("event", "view_search_results", {
                        search_term: $scope.searchTerm,
                    });
                }
                $scope.getSearchURL();
                window.location = $scope.searchURL;
            }
        };

        $scope.closeSuggestions = function () {
            $scope.searchTerm = "";
            $scope.suggest();
            $scope.applySearchBackground(false);
        };

        $scope.searchBtnClick = function (event) {
            if (
                $scope.searchTerm != null &&
                $scope.searchTerm != undefined &&
                $scope.searchTerm != ""
            )
                $scope.search();
            else {
                alert("Please enter search term");
                event.preventDefault();
            }
        };

        function checkIsSVG() {
            var svgSearchWords = ["svg", "dxf", "cuttable", "heat transfer"];
            return svgSearchWords.indexOf($scope.searchTerm.toLowerCase()) > -1;
        }

        function checkIsCustomDigitizing() {
            var cdSearchWords = [
                "custom",
                "customdigitizing",
                "custom digitizing",
                "digitizing",
                "embroidery digitizing",
            ];
            return cdSearchWords.indexOf($scope.searchTerm.toLowerCase()) > -1;
        }

        $scope.getSearchURL = function () {
            var e = document.getElementById("ddlSearchDefName");
            var defName = "";
            if (angular.isDefined(e)) {
                defName = e.value.toLowerCase();
            } else {
                defName = "all";
            }
            var searchTerm = encodeURIComponent(
                $scope.searchTerm.replace(/[\s+]/g, "-")
            ).toLowerCase();
           
            $scope.searchURL = "/sitesearch/" + searchTerm;
            if (defName == "stockdesign") {
                $scope.searchURL =
                    "/designsearchresults?searchterm=" + searchTerm;
            } else if (
                defName == "designpack" ||
                defName == "font" ||
                defName == "fontpack"
            ) {
                $scope.searchURL =
                    "/" + defName + "listings?searchterm=" + searchTerm;
            } else if (
                defName == "quilting" ||
                defName == "software" ||
                defName == "supplies"
            ) {
                $scope.searchURL =
                    "/" + defName + "/productlistings?searchterm=" + searchTerm;
            }
        };

        //#endregion
    },
]);

storefrontApp.filter("formatQueryStringWithSpace", function () {
    return function (X) {
        if (X != undefined) return X.replace(/\s/g, "-").toLowerCase();
        else return X;
    };
});
